// Espelha TipoDocumentoItemVendaEnum do OrquestradorVendas: o documento de onde vem um item vendido ao
// cliente (aba Produtos das últimas vendas). 1 e 2 têm os mesmos valores de VendaTipoDocumentoEnum.
export enum TipoDocumentoItemVendaEnum {
    Orcamento = 1,
    PedidoDeVenda = 2,
    NotaFiscal = 3,
}
